import { PairingStatus } from '~/app/enums/PairingStatus';
import { TherapyJobStatus } from '~/app/enums/TherapyJobStatus';
import { TherapyJobV2 } from '~/app/models/TherapyJobV2';

export const detachedDripChamber = (tj: Partial<TherapyJobV2>) => {
  const noDetected = tj.dripChamberDetected === false;
  const inRunning = tj.status === TherapyJobStatus.RUNNING;
  const unPaired = tj.pairingState === PairingStatus.UN_PAIRED || tj.pairingState === null;

  return noDetected && !unPaired && inRunning;
};
